import { render, staticRenderFns } from "./AuthorInfo.vue?vue&type=template&id=8964689a&scoped=true"
import script from "./AuthorInfo.vue?vue&type=script&lang=js"
export * from "./AuthorInfo.vue?vue&type=script&lang=js"
import style0 from "./AuthorInfo.vue?vue&type=style&index=0&id=8964689a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8964689a",
  null
  
)

export default component.exports